/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AchievementsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxUlEQVR4nO1VvUoDQRA+URRt/C18g4D6DmmDdzuzKcaZCJI0KfU5LPUFtNK0dpJaCwUFBR/BKApqE7BUZpO9nJdfE8XGgSGXuW++b2ZnNgmCvzZjGQH5HbFgfEyfNQYgMLIAWCmDlQ+DUolFUSoa03ffJsxmsxNaYRhuzjsBoIwTsFxLdFVzAkAZ/W7t1iLkZcfn9DTXvquOb6OosOREUE4A+TTuCuUckM/0WTGKbXa53VdAq/AJgFLthSWicUC59gUR0UJfgbgqlCpY2e2Fy+VyU2DlXkV8t11NN8INtHmuqUonDfI+WH5VNyh7GvMiOrfEvMqQlzDNMebWrrEZOtCL5Etj5cC/a2Hk4AsG+TKR/9bWQXO3jw3yg7F8lUgspcljIuSSL1BzNFc5OnXQ0YyRVbBcbxHKi3pLhOuKCYa1ML+xZpCfnFuOkt36uGKGIl8nWtZPIppVbxAX59TTcY8d2IyVIqA8J39/dMt81em4YjVnIHIAWkmfO7j1TA84Hee65vYkJ6JpQLnptjXQ1/kuiqKZ7tVbORyeXPz9OOp+7iOSQ0ukfR6A8vhzAlxr70Bv4W8KoF4e/0cyIrlJXMp/C/rZJ2CYxDPCBkHbAAAAAElFTkSuQmCC)
 */
export const AchievementsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.76 4.97a1 1 0 0 1-.73-1.21l.5-2a1 1 0 1 1 1.94.48l-.5 2a1 1 0 0 1-1.21.73ZM19.2 3.8a1 1 0 0 1 0 1.4l-1.5 1.5a1 1 0 1 1-1.4-1.4l1.5-1.5a1 1 0 0 1 1.4 0ZM7.46 11.05 9.6 8.2a3 3 0 0 1 4.8 0l2.14 2.85-.83.83a1 1 0 0 1-1.42 0l-.17-.17a3 3 0 0 0-4.24 0l-.17.17a1 1 0 0 1-1.42 0l-.83-.83ZM6.25 12.67 2.4 17.8A2 2 0 0 0 4 21h16a2 2 0 0 0 1.6-3.2l-3.85-5.13-.63.62a3 3 0 0 1-4.24 0l-.17-.17a1 1 0 0 0-1.42 0l-.17.17a3 3 0 0 1-4.24 0l-.63-.62ZM4.8 5.2a1 1 0 0 1 1.4-1.4l1.5 1.5a1 1 0 0 1-1.4 1.4L4.8 5.2ZM21.97 8.26a1 1 0 0 1-.73 1.21l-2 .5a1 1 0 1 1-.48-1.94l2-.5a1 1 0 0 1 1.21.73ZM2.76 9.47a1 1 0 1 1 .48-1.94l2 .5a1 1 0 1 1-.48 1.94l-2-.5ZM10.97 3.76a1 1 0 0 1-1.94.48l-.5-2a1 1 0 1 1 1.94-.48l.5 2Z"
        className={colorClass}
      />
    </svg>
  );
};
